export const pageTitlesConfig = {
    dashboard: 'Dashboard',
    routes: 'Routes',
    emergency: 'Emergency',
    intersections: 'Intersections',
    help: 'Help',
    'business-rules': 'Business Rules',
};
